import './App.css';
import Components from './Components/index'

const App = () => {
	const { MainComponent } = Components
	return (
		<div style={{height: '100vh'}}>
			<MainComponent></MainComponent>
		</div>
	);
}

export default App;
